import Vue from "vue";
import Router from "vue-router";
import search from "../view/search";
// const home = ()=>import("../view/home")
import home from "../view/home";
import iPage from "../view/rightPage/iPage";
// const iPage = ()=>import("../view/rightPage/iPage")
import iPage_sub from "../view/rightPage/iPage_sub";
import tongZhi from "../view/rightPage/tongZhi";
import activity from "../view/rightPage/activity";
import information from "../view/rightPage/information";
import special from "../view/rightPage/special";
import invite from "../view/rightPage/invite";
import video from "../view/rightPage/video";
import ghDetails from "../view/details/graphicDetails";
import ptDetails from "../view/details/postDetails";
import vdDetails from "../view/details/videoDetails";
import searchResult from "../view/details/searchResult";
import specialList from "../view/details/specialList";
import my from "../view/myData/my";
import perData from "../view/myData/perData";
import myAccount from "../view/myData/myAccount";
import myCollect from "../view/myData/myCollect";
import myMsg from "../view/myData/myMsg";
import myCare from "../view/myData/myCare";
import myFans from "../view/myData/myFans";
import personal from "../view/myData/personal";
import login from "../view/login/login";
import authentic from "../view/login/authentic";
import person from "../view/media/person";
import checkPass from "../view/media/checkPass";
import mediaOrg from "../view/media/mediaOrg";
import register from "../view/login/register";
import changePassword from "../view/login/changePassword";
import bindWeibo from "../view/login/bindWeibo";
import graphicData from "../view/media/graphicData";
import graphicManage from "../view/media/graphicManage";
import inviteManage from "../view/media/inviteManage";
import dynamiManage from "../view/media/dynamiManage";
import publish from "../view/media/publish";
import publishArticle from "../view/media/publishArticle";
import publishInvite from "../view/media/publishInvite";
import publishDynamic from "../view/media/publishDynamic";
import publishVideo from "../view/media/publishVideo";
import publishLianjie from "../view/media/publishLianjie";
import setAccount from "../view/media/setAccount";
import subscribeData from "../view/media/subscribeData";
import sync from "../view/media/sync";
import videoData from "../view/media/videoData";
import videoManage from "../view/media/videoManage";
import DataAnalysis from "../view/media/dataAnalysis";

Vue.use(Router);
const router = new Router({
  mode:'hash',
  routes: [
    {
      path: "/",
      name: "home",
      redirect: "/iPage",
      component: home,
      children: [
        {
          path: "/iPage",
          name: "iPage",
          meta: {
            title: "首页-建筑档案"
          },
          component: iPage
        },
        {
          path: "/iPage_sub",
          name: "iPage_sub",
          meta: {
            title: "首页-建筑档案"
          },
          component: iPage_sub
        },
        {
          path: "/tongZhi",
          name: "tongZhi",
          meta: {
            title: "通知"
          },
          component: tongZhi
        },
        {
          path: "/activity",
          name: "activity",
          meta: {
            title: "活动-建筑档案"
          },
          component: activity
        },
        {
          path: "/information",
          name: "information",
          meta: {
            title: "记录-建筑档案"
          },
          component: information
        },
        {
          path: "/invite",
          name: "invite",
          meta: {
            title: "工作-建筑档案"
          },
          component: invite
        },
        {
          path: "/ghDetails",
          name: "ghDetails",
          meta: {
            title: "建筑档案"
          },
          component: ghDetails
        },
        {
          path: "/specialList",
          name: "specialList",
          meta: {
            title: "档案列表-建筑档案"
          },
          component: specialList
        },
        {
          path: "/ptDetails",
          name: "ptDetails",
          meta: {
            title: "建筑档案"
          },
          component: ptDetails
        },
        {
          path: "/vdDetails",
          name: "vdDetails",
          meta: {
            title: "建筑档案"
          },
          component: vdDetails
        },
        {
          path: "/searchResult",
          name: "searchResult",
          meta: {
            title: "搜索-建筑档案"
          },
          component: searchResult
        },
        {
          path: "/personal",
          name: "personal",
          meta: {
            title: "个人主页-建筑档案"
          },
          component: personal
        },
        {
          path: "/video",
          name: "video",
          meta: {
            title: "视频-建筑档案"
          },
          component: video
        },
        {
          path: "/special",
          name: "special",
          meta: {
            title: "档案-建筑档案"
          },
          component: special
        },
        {
          path: "/graphicData",
          name: "graphicData",
          component: graphicData
        },
        {
          path: "/graphicManage",
          name: "graphicManage",
          meta: {
            title: "图文管理-建筑档案"
          },
          component: graphicManage
        },
        {
          path: "/dynamiManage",
          name: "dynamiManage",
          meta: {
            title: "动态管理-建筑档案"
          },
          component: dynamiManage
        },
        {
          path: "/inviteManage",
          name: "inviteManage",
          meta: {
            title: "工作管理-建筑档案"
          },
          component: inviteManage
        },
        {
          path: "/publish",
          name: "publish",
          meta: {
            title: "发布-建筑档案"
          },
          component: publish,
          children: [
            {
              path: "/publishArticle",
              name: "publishArticle",
              meta: {
                title: "发布文章-建筑档案"
              },
              component: publishArticle
            },

            {
              path: "/publishDynamic",
              name: "publishDynamic",
              meta: {
                title: "发布动态-建筑档案"
              },
              component: publishDynamic
            },
            {
              path: "/publishVideo",
              name: "publishVideo",
              meta: {
                title: "发布视频-建筑档案"
              },
              component: publishVideo
            },
            {
              path: "/publishInvite",
              name: "publishInvite",
              meta: {
                title: "发布工作-建筑档案"
              },
              component: publishInvite
            },
			{
			  path: "/publishLianjie",
			  name: "publishLianjie",
			  meta: {
			    title: "一键发布-建筑档案"
			  },
			  component: publishLianjie
			}
          ]
        },
        {
          path: "/setAccount",
          name: "setAccount",
          meta: {
            title: "账户设置-建筑档案"
          },
          component: setAccount
        },
        {
          path: "/dataAnalysis",
          name: "dataAnalysis",
          meta: {
            title: "数据分析-建筑档案"
          },
          component: DataAnalysis
        },
        {
          path: "/subscribeData",
          name: "subscribeData",
          component: subscribeData
        },
        {
          path: "/sync",
          name: "sync",
          component: sync
        },
        {
          path: "/videoData",
          name: "videoData",
          component: videoData
        },
        {
          path: "/videoManage",
          name: "videoManage",
          meta: {
            title: "视频管理-建筑档案"
          },
          component: videoManage
        },
        {
          path: "/my",
          name: "my",
          meta: {
            title: "基本资料-建筑档案"
          },
          component: my,
          children: [
            {
              path: "/perData",
              name: "perData",
              meta: {
                title: "基本资料-建筑档案"
              },
              component: perData
            },
            {
              path: "/myAccount",
              name: "myAccount",
              meta: {
                title: "账号密码-建筑档案"
              },
              component: myAccount
            },
            {
              path: "/myCollect",
              name: "myCollect",
              meta: {
                title: "我的收藏-建筑档案"
              },
              component: myCollect
            },
            {
              path: "/myMsg",
              name: "myMsg",
              meta: {
                title: "我的消息-建筑档案"
              },
              component: myMsg
            },
            {
              path: "/myCare",
              name: "myCare",
              meta: {
                title: "我的关注-建筑档案"
              },
              component: myCare
            }
          ]
        },
        {
          path: "/myFans",
          name: "myFans",
          component: myFans
        },
        {
          path: "/search",
          name: "search",
          meta: {
            title: "搜索-建筑档案"
          },
          component: search
        },
        {
          path: "/authentic",
          name: "authentic",
          meta: {
            title: "认证中心-建筑档案"
          },
          component: authentic
        },
        {
          path: "/person",
          name: "person",
          meta: {
            title: "认证中心-建筑档案"
          },
          component: person
        },
        {
          path: "/mediaOrg",
          name: "mediaOrg",
          meta: {
            title: "认证中心-建筑档案"
          },
          component: mediaOrg
        },
        {
          path: "/checkPass",
          name: "checkPass",
          meta: {
            title: "审核状态-建筑档案"
          },
          component: checkPass
        },
        {
          path: "/login",
          name: "login",
          component: login
        },
        {
          path: "/register",
          name: "register",
          component: register
        },
        {
          path: "/changePassword",
          name: "changePassword",
          component: changePassword
        },
        {
          path: "/bindWeibo",
          name: "bindWeibo",
          component: bindWeibo
        }
      ]
    }
  ]
});
router.beforeEach((to, from, next) => {
  if (to.path == "/iPage") {
    localStorage.setItem("setleftNav", 0);
    next();
  }
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

export default router;
